// @flow
import { useLoadUsersLabels } from 'queries/users/useLoadUsers'
import * as React from 'react'
import Select from 'react-select'
import Ui from 'ui'

import { SectionFormSettings } from '@/ui/atoms/SectionFormSettings'
type Props = {
  notificationUsers: string[],
  setNotificationUsers: Function,
}

function NotificationsForm({
  notificationUsers,
  setNotificationUsers,
}: Props): React.Node {
  const { data: users = [], isUsersLoading } = useLoadUsersLabels({
    staleTime: 60 * 1000,
    cacheTime: 60 * 1000,
  })

  const teamUsers = React.useMemo(
    () =>
      users?.map((user) => ({
        value: user.id,
        label: user.email,
      })),
    [users]
  )

  return (
    <SectionFormSettings.Root>
      <Ui.QuestionTitle>Recipients</Ui.QuestionTitle>
      <Select
        isMulti
        defaultValue={[]}
        isLoading={isUsersLoading}
        name="notifySubmits"
        onChange={(selected) => {
          const selectedUsers = selected?.map((user) => user.value) || []
          setNotificationUsers(selectedUsers)
        }}
        options={teamUsers}
        placeholder="Select email addresses"
        value={teamUsers?.filter((user) =>
          notificationUsers.includes(user.value)
        )}
      />
    </SectionFormSettings.Root>
  )
}

export default NotificationsForm
